import React from 'react';
import { Grid, Stack } from '@mui/material';
import styled from '@emotion/styled';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import FilterLayoutItemDraggable from '@/components/_common/Filters/FilterLayoutsModal/FilterLayoutItemDraggable';
import { FilterLayoutsFilter } from '@/redux/slices/slice_types';

interface Props {
  columnName: 'show' | 'hide';
  items: FilterLayoutsFilter[];
  togglePin: (columnName: 'show' | 'hide', id: string) => void;
}

const FilterLayoutColumn: React.FC<Props> = ({ columnName, items, togglePin }) => {
  const { setNodeRef } = useDroppable({
    id: columnName,
    data: { columnName }
  });

  return (
    <SortableContext id={columnName} items={items.map((item) => item.id)} strategy={verticalListSortingStrategy}>
      <Column item>
        <ColumnTitle>{columnName === 'show' ? 'Show' : 'Hide'}</ColumnTitle>
        <ItemsWrapper ref={setNodeRef} gap={1}>
          {items.map((item, index) => (
            <FilterLayoutItemDraggable
              key={item.id}
              item={item}
              columnName={columnName}
              index={index}
              isOnlyChild={items.length === 1}
              togglePin={togglePin}
            />
          ))}
        </ItemsWrapper>
      </Column>
    </SortableContext>
  );
};

export default FilterLayoutColumn;

const Column = styled(Grid)`
  flex-grow: 1;
  flex-shrink: 0;
  flex-basis: 0; // this line prevents column from shrinking when there is no filter items in it
`;

const ColumnTitle = styled.h3`
  opacity: 0.5;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  font-size: 1.357rem;
  font-weight: 700;
`;

const ItemsWrapper = styled(Stack)`
  padding: ${({ theme }) => theme.spacing(2)};
  height: 463px;
  overflow: auto;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  border-radius: ${({ theme }) => `${theme.shape.borderRadius * 1.6}px`};
`;
